<template>
  <a
    :class="b()"
    :href="url"
  >
    <div :class="b('image')">
      <div
        v-if="item.type && ['eifuasset'].includes(item.type)"
        :class="b('icon')"
      ></div>
      <e-picture
        v-else-if="item.image"
        :sizes="sizes"
        :srcset="item.image.srcset"
        :fallback="item.image.fallback"
        :alt="item.image.alt"
        :ratio="4 / 3"
      />
      <div
        v-else
        :class="b('fallback-image')"
      ></div>
    </div>
    <span
      v-if="item.title"
      :class="b('text')"
      :title="`${item.title} ${item.language ? `- (${item.language})` : ''}`"
    >
      {{ item.title }}
      <span
        v-if="item.language"
        :class="b('language')"
        >- ({{ item.language }})</span
      >
    </span>
    <span
      v-else-if="item.brandNames && item.brandNames.length"
      :class="b('text')"
      :title="getElectronicInstructionBrandNames(item)"
    >
      {{ getElectronicInstructionBrandNames(item) }}
    </span>
    <span
      v-if="item.price"
      :class="b('price')"
    >
      {{ item.price }}
    </span>
  </a>
</template>

<script>
  import { URL_PARAM_MAP } from '@/setup/globals';
  import useSessionStore from '@/stores/session';
  import ePicture from '@/elements/e-picture.vue';
  import getElectronicInstructionBrandNames from '@/helpers/get-electronic-instruction-brand-names.js';

  /**
   * Renders a search suggestion item.
   */
  export default {
    name: 'c-search-suggestion',
    components: {
      ePicture,
    },

    // mixins: [],

    props: {
      /**
       * Gets an entry item.
       */
      item: {
        type: Object,
        required: true,
      },
    },
    setup() {
      return {
        sessionStore: useSessionStore(),
      };
    },
    data() {
      return {
        /**
         * @type {Object} Defines the sizes for the e-picture component.
         */
        sizes: {
          xs: 60,
        },
      };
    },

    computed: {
      /**
       * Returns a detail view url.
       *
       * @returns {String}
       */
      url() {
        const { item } = this;

        if (item.url) {
          return item.url;
        }

        const { urls } = this.sessionStore;

        return urls.eifuLandingpage
          ? `${urls.eifuLandingpage}?${URL_PARAM_MAP.documentId}=${item.id}&${URL_PARAM_MAP.showEifuDetail}=1`
          : null;
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    methods: {
      /**
       * Helper function.
       */
      getElectronicInstructionBrandNames,
    },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-search-suggestion {
    @include mixins.font(variables.$font-size--18, 24px, variables.$font-weight--regular);

    display: flex;
    align-items: center;
    color: variables.$color-primary--1;

    &:hover,
    &:focus {
      color: variables.$color-primary--2;
    }

    &__image {
      position: relative;
      flex: 1 0 functions.rem(60px);
      max-width: functions.rem(60px);
      min-height: functions.rem(45px);

      img {
        max-width: 100%;
      }
    }

    &__fallback-image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url('../assets/placeholder/placeholder.svg') no-repeat center center variables.$color-grayscale--920;
      background-size: 40%;
    }

    &__icon {
      position: absolute;
      inset: 0;
      background: variables.$color-grayscale--920;

      &::before {
        @include mixins.iconSprite('i-electronic-instruction', 50%, variables.$color-primary--1);

        position: absolute;
        content: '';
        left: 25%;
        top: 25%;
      }
    }

    &__text {
      @include mixins.line-clamp(2, 1.3);

      flex: 1 1 auto;
      padding-left: functions.rem(variables.$spacing--20);
      text-overflow: ellipsis;
    }

    &__language {
      font-style: italic;
    }

    &__price {
      display: none;

      @include mixins.media(md) {
        display: block;
        flex: 0 0 functions.rem(125px);
        text-align: right;
      }
    }
  }
</style>
